import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row gx-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Create Access Codes", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Add the codes you would like to create below. Put each code on its own line. The code format is two alpha characters followed by six digits. You can create up to 500 codes at a time. ", -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "fs-6 mt-2" }
const _hoisted_9 = { class: "row gx-5 mt-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_11 = { class: "col border-top pt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-2" }, "Delete Access Codes", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Delete all unused access codes that match a case insensitive starting pattern. For example, enter 'A' below to match all unused codes that start with the letter 'A'. If you want to delete all unused codes that start 'AG' then enter 'AG'. An unused code is one where there is no activity recorded against that code. ", -1)
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "fs-6 mt-2" }

import { ref } from "vue";
import { app } from "../ts/app";
import DataResult from "../ts/dataResult";


export default /*#__PURE__*/_defineComponent({
  __name: 'Admin',
  setup(__props) {

const codes = ref("");
const createCommandFeedback = ref("");
const deleteCodesStartingWith = ref("");
const deleteCommandFeedback = ref("");
const isExecuting = ref(false);

const onGenerateCodesClicked = async function() {
    isExecuting.value = true;

    createCommandFeedback.value = "";

    const getCodeArrayResult = getCodeArray();

    if (!getCodeArrayResult.successful) {
        createCommandFeedback.value = getCodeArrayResult.message;
        isExecuting.value = false;
        return;
    }

    const result = await app.generateCodes(getCodeArrayResult.data);

    createCommandFeedback.value = result.successful ? "The codes were created." : result.message;
    isExecuting.value = false;
}

const onDeleteCodesClicked = async function() {
    deleteCommandFeedback.value = "";

    if (!deleteCodesStartingWith.value || deleteCodesStartingWith.value.trim().length == 0) {
        deleteCommandFeedback.value = "No starting pattern for codes defined.";
        return;
    }

    if (!(/[a-zA-Z0-9]+$/.test(deleteCodesStartingWith.value))) {
        deleteCommandFeedback.value = "The starting pattern can contain only alphanumeric characters.";
        return;
    }

    isExecuting.value = true;

    const result = await app.deleteCodes(deleteCodesStartingWith.value);

    deleteCommandFeedback.value = result.message;
    isExecuting.value = false;
}

const getCodeArray = function(): DataResult<Array<string>> {
    if (codes.value.length == 0) {
        return new DataResult(false, "No codes defined.", []);
    }

    const goodCodes = new Array<string>();    
    const badCodes = new Array<string>();
    
    const candidateCodes = codes.value.split("\n");

    for (const candidateCode of candidateCodes) {
        if (!isValidCode(candidateCode)) {
            badCodes.push(candidateCode);
            continue;
        }

        goodCodes.push(candidateCode);
    }

    const successful = goodCodes.length > 0 && badCodes.length == 0;

    let message = "";
    
    if (goodCodes.length == 0) {
        message = "No valid codes were defined.";
    }

    if (badCodes.length > 0) {
        message += ` The following invalid codes were found: ${badCodes.toString()}`;
    }

    return new DataResult(successful, message, goodCodes);
}

function isValidCode(code: string): boolean {
    return /[a-zA-Z]{2}\d{6}/.test(code);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codes).value = $event)),
          class: "w-100"
        }, null, 512), [
          [_vModelText, codes.value]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary mt-3",
          onClick: onGenerateCodesClicked,
          disabled: isExecuting.value
        }, "Create ", 8, _hoisted_7),
        _createElementVNode("p", _hoisted_8, _toDisplayString(createCommandFeedback.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((deleteCodesStartingWith).value = $event)),
          class: "w-100",
          maxlength: "9"
        }, null, 512), [
          [_vModelText, deleteCodesStartingWith.value]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary mt-4 pt-2",
          onClick: onDeleteCodesClicked,
          disabled: isExecuting.value
        }, "Delete ", 8, _hoisted_14),
        _createElementVNode("p", _hoisted_15, _toDisplayString(deleteCommandFeedback.value), 1)
      ])
    ])
  ]))
}
}

})